import { createTransition } from "flemo";

export const fadeTransition = createTransition({
  name: "fade",
  initial: {
    opacity: 0,
    transition: {
      duration: 0,
    },
  },
  idle: {
    value: {
      opacity: 1,
    },
    options: {
      duration: 0,
    },
  },
  enter: {
    value: {
      opacity: 1,
    },
    options: {
      duration: 0.2,
    },
  },
  enterBack: {
    value: {
      opacity: 0,
    },
    options: {
      duration: 0.2,
    },
  },
  exit: {
    value: {
      opacity: 0,
    },
    options: {
      duration: 0.2,
    },
  },
  exitBack: {
    value: {
      opacity: 1,
    },
    options: {
      duration: 0.2,
    },
  },
});
